import { render, staticRenderFns } from "./electronicbillPFZL.vue?vue&type=template&id=f91e672c"
import script from "./electronicbillPFZL.vue?vue&type=script&lang=js"
export * from "./electronicbillPFZL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports